"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.context = exports.Provider = void 0;

var _react = require("react");

var context = /*#__PURE__*/(0, _react.createContext)({
  routes: [],
  events: null,
  modules: null,
  navigation: []
});
exports.context = context;
var Provider = context.Provider;
exports.Provider = Provider;